import api, { apiPrefix } from './Api';

const forgotPasswordApiPrefix = `${apiPrefix}/forgot-password`;

export const sendForgotPasswordEmail = async (email: string): Promise<void> =>
  api.post(forgotPasswordApiPrefix, { email });
